import React from "react";
import "./Mission.scss";
import Helpers from "@utils/Helpers";

const Mission: React.FC = () => {
  return (
    <div className="Mission-section">
      <div className="first-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="first-section-content">
                <div className="section-title">What We Do</div>
                <div className="section-description">
                  <span>Hay2U</span> connects farm producers with buyers
                  enabling direct product sales. The advantage of this service
                  is the organization of producers creating a comprehensive
                  catalogue of products available to a wide geographic market.
                  This enables buyers and sellers anywhere in the world to deal
                  directly versus selling and buying in isolated markets
                  regulated by dominant players.
                  <br></br>
                  <br></br>
                  <ul>
                    <li>
                      Direct-to-consumer sales platform that removes the
                      third-party sale presence.
                    </li>
                    <li>
                      Provide negotiation power to both sellers and consumers.
                    </li>
                    <li>
                      Provide payment options for both sellers and buyers in a safe platform.
                    </li>
                    <li>
                      Allow credit card payment options so you can enjoy your credit card benefits.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <img
                src={Helpers.getImageFrontPage("mission")}
                className="w-100 img-fluid"
                alt="mission"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="second-section">
        <div className="container">
          <div className="section-wrap">
            <div className="section-title">Our Mission</div>
            <div className="section-description">
              “To empower producers and buyers to engage in direct, transparent
              transactions, building strong partnerships and fostering
              sustainable trade.”
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
